import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages} from 'react-intl';

import SeoInternalLinks from '../react-seo-internal-links';

const messages = defineMessages({
  title: {
    id: 'Citypage.ChildSEOLinks.Venue.Title',
    defaultMessage: 'Top Venues in {cityName}',
    description: 'Top Venues in {cityName}',
  },
});

class SeoCityVenues extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {entityName, venueLinks = [], entityType, entityId, intl} = this.props;
    const title = intl.formatMessage(messages.title, {cityName: entityName});

    return venueLinks.length > 0 ? (
      <SeoInternalLinks entityType={entityType} entityId={entityId} seoLinks={venueLinks} title={title} />
    ) : null;
  }
}
SeoCityVenues.propTypes = {
  entityName: PropTypes.string,
  entityId: PropTypes.number,
  entityType: PropTypes.string,
  venueLinks: PropTypes.array,

  /** The intl object */
  intl: PropTypes.object.isRequired,
};

export default injectIntl(SeoCityVenues);
